"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTemplateVersion = exports.updateTemplateVersion = exports.updateTemplate = exports.deleteTemplate = exports.getTemplate = exports.activateTemplateVersion = exports.activateTemplate = exports.deleteTemplateVersion = exports.addTemplateVersion = exports.addTemplate = exports.getLanguageTemplateVersions = exports.getTemplateVersions = exports.getTemplates = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const _ = require("lodash");
const getTemplates = async (supabase) => {
    const { data, error } = await supabase.from("email_templates").select(`*,     
    versions:email_template_versions(*, language:languages(*))`);
    if (!error) {
        return data.map((template) => {
            return {
                ...template,
            };
        });
    }
    return error;
};
exports.getTemplates = getTemplates;
const getTemplateVersions = async (supabase, template_id) => {
    const { data, error } = await supabase
        .from("email_template_versions")
        .select(`*`)
        .eq("template_id", template_id)
        .order("version", { ascending: false });
    if (!error) {
        return data.map((template) => {
            return {
                ...template,
            };
        });
    }
    return error;
};
exports.getTemplateVersions = getTemplateVersions;
const getLanguageTemplateVersions = async (supabase, template_id, language_id) => {
    const { data, error } = await supabase
        .from("email_template_versions")
        .select(`*`)
        .eq("template_id", template_id)
        .eq("language_id", language_id)
        .order("version", { ascending: false });
    if (!error) {
        return data.map((template) => {
            return {
                ...template,
            };
        });
    }
    return error;
};
exports.getLanguageTemplateVersions = getLanguageTemplateVersions;
const addTemplate = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        obj.modified_by = user?.id;
        obj.created_by = user?.id;
    }
    const { data, error } = await supabase.from("email_templates").insert([obj]);
    if (!error)
        return data;
    return error;
};
exports.addTemplate = addTemplate;
const addTemplateVersion = async (supabase, template_id, language_id) => {
    const { data: { user }, } = await supabase.auth.getUser();
    // get existing template versions and get the latest version number
    const versions = await (0, exports.getLanguageTemplateVersions)(supabase, template_id, language_id).then((res) => {
        if (res.code) {
            return;
        }
        else {
            const c = res;
            return c;
        }
    });
    if (!versions)
        return new Error("Error getting template versions");
    const latestVersion = versions.length > 0 ? versions[0].version : 1;
    const subject = versions.length > 0 ? versions[0].subject : "";
    const snippet = versions.length > 0 ? versions[0].snippet : "";
    const dataObj = versions.length > 0 ? versions[0].data : {};
    const obj = {
        active: false,
        template_id: template_id,
        language_id: language_id,
        version: latestVersion,
        text: "",
        html: "",
        subject: subject,
        snippet: snippet,
        data: dataObj,
        created_by: user?.id,
        modified_by: user?.id,
    };
    const { data, error } = await supabase
        .from("email_template_versions")
        .insert([obj])
        .select();
    if (!error)
        return data[0];
    return error;
};
exports.addTemplateVersion = addTemplateVersion;
const deleteTemplateVersion = async (supabase, id) => {
    const { error } = await supabase
        .from("email_template_versions")
        .delete()
        .eq("id", id);
    return error;
};
exports.deleteTemplateVersion = deleteTemplateVersion;
const activateTemplate = async (supabase, id, active) => {
    const { data, error } = await supabase
        .from("email_templates")
        .update({ active: active })
        .eq("id", id)
        .select();
    if (error)
        return error;
};
exports.activateTemplate = activateTemplate;
const activateTemplateVersion = async (supabase, id) => {
    // update the active flag on the template version to true
    const { data, error } = await supabase
        .from("email_template_versions")
        .update({ active: true })
        .eq("id", id)
        .select();
    if (error)
        return error;
    // get the template id and language id from the template version and update all other versions to false
    const { template_id, language_id } = data[0];
    const { error: error2 } = await supabase
        .from("email_template_versions")
        .update({ active: false })
        .neq("id", id)
        .eq("template_id", template_id)
        .eq("language_id", language_id);
    if (error2)
        return error2;
    return data;
};
exports.activateTemplateVersion = activateTemplateVersion;
const getTemplate = async (supabase, id) => {
    const { data, error } = await supabase
        .from("email_templates")
        .select(`*,
      versions:email_template_versions(*,
        
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)),
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getTemplate = getTemplate;
const deleteTemplate = async (supabase, id) => {
    const { error } = await supabase
        .from("email_templates")
        .delete()
        .eq("id", id);
    return error;
};
exports.deleteTemplate = deleteTemplate;
const updateTemplate = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        updateObj.modified_by = user?.id;
    }
    delete updateObj.created_by_user;
    delete updateObj.modified_by_user;
    const { data, error } = await supabase
        .from("email_templates")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .single();
    if (!error)
        return data;
    return error;
};
exports.updateTemplate = updateTemplate;
const updateTemplateVersion = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id)
        updateObj.modified_by = user?.id;
    updateObj.modified_at = new Date();
    delete updateObj.created_by_user;
    delete updateObj.modified_by_user;
    delete updateObj.email_template;
    const { data, error } = await supabase
        .from("email_template_versions")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select(`*,
      email_template:template_id(*),
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .single();
    if (!error)
        return data;
    return error;
};
exports.updateTemplateVersion = updateTemplateVersion;
const getTemplateVersion = async (supabase, id) => {
    const { data, error } = await supabase
        .from("email_template_versions")
        .select(`*,
      email_template:template_id(*),
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getTemplateVersion = getTemplateVersion;
